<template>
	<div>
    <section class="index">
      <div class="main-content">
        <nav class="header-nav">
          <span class="logo"><img src="../assets/logo.png"/></span>
          <ul class="nav-menu">
            <li class="active">首页</li>
            <li>关于我们</li>
            <li>我们的产品</li>
            <li>联系我们</li>
          </ul>
        </nav>
        <h1><img alt="科技合能，美好生活" src="../assets/slogan.png"/></h1>
      </div>
    </section>
    <section class="aboutus">
      <div class="main-content">
        <h2><img src="../assets/aboutus.png" alt="关于我们"/></h2>
        <div class="desc">彩住科技是一家互联网公司，致力于通过技术提升<br/>用户生活品质，提高企业管理效率。</div>
        <div class="profile">
          <div class="profile-scroll">
            <div class="team item" @mouseover="showContent(1)" @mouseout="hideContent(1)">
              <div class="t1">
                <p class="num">01</p>
                <p class="title">彩住团队</p>
                <p class="content active" v-if="curr === 1">上海彩住科技有限责任公司核心成员为来自腾讯、百度、360等互联网公司的技术精英，从事大型分布式系统开发10年以上经验，对互联网行业有深入的技术积累和研究。</p>
              </div>
            </div>
            <div class="tech item"  @mouseover="showContent(2)" @mouseout="hideContent(2)">
              <div class="t1">
                <p class="num">02</p>
                <p class="title">技术驱动</p>
                <p class="content active" v-if="curr === 2">作为科技驱动型公司，彩住科技借助大数据及人工智能能力，更好地了解用户偏好和行为，向用户提供定制化产品及服务</p>
              </div>
            </div>
            <div class="joinus item"  @mouseover="showContent(3)" @mouseout="hideContent(3)">
              <div class="t1">
                <p class="num">03</p>
                <p class="title">加入我们</p>
                <p class="content active" v-if="curr === 3">更多职位，敬请期待</p>
              </div>
            </div>
          </div>
        </div>
        <div class="profile1">
          <slider animation="fade" :autoplay="false" :indicators="false">
            <slider-item>
              <div class="team item" >
                <div class="t1">
                  <p class="num">01</p>
                  <p class="title">彩住团队</p>
                  <p class="content active" >上海彩住科技有限责任公司核心成员为来自腾讯、百度、360等互联网公司的技术精英，从事大型分布式系统开发10年以上经验，对互联网行业有深入的技术积累和研究。</p>
                </div>
              </div>
            </slider-item>
            <slider-item>
              <div class="tech item"  >
                <div class="t1">
                  <p class="num">02</p>
                  <p class="title">技术驱动</p>
                  <p class="content active" >作为科技驱动型公司，彩住科技借助大数据及人工智能能力，更好地了解用户偏好和行为，向用户提供定制化产品及服务</p>
                </div>
              </div>
            </slider-item>
            <slider-item>
               <div class="joinus item" >
                <div class="t1">
                  <p class="num">03</p>
                  <p class="title">加入我们</p>
                  <p class="content active" >更多职位，敬请期待</p>
                </div>
              </div>
            </slider-item>
          </slider>
        </div>
      </div>
    </section>
    <section class="product">
      <div class="main-content">
        <h2><img src="../assets/products.png" alt="我们的产品"/></h2>
        <div class="content">
          <div class="left">
            <div class="header"><img src="../assets/color.png"/><h3>彩住旅行</h3></div>
            <p>彩住旅行是以技术为驱动的在线旅游业务基础设施服务商，作为科技驱动型公司，彩住旅行借助大数据及人工智能能力，更好地了解用户偏好和行为，向用户提供定制化产品及服务。透过对用户体验及先进技术能力的深入了解，彩住正彻底改变消费者对在线旅游行业的期望，使得旅游过程更方便、更具个性化及更愉快。</p>
            <p>彩住旅行的产品主要包括：酒店智能OTA营销系统、酒店精准营销投放服务、酒店智能自助机帮助客户在新零售时代提高运营效率和盈利能力。</p>
          </div>
          <img src="../assets/product2.png" class="img-product"/>
        </div>
      </div>
    </section>
    <section class="product" style="background:#fff">
      <div class="main-content fixed">
        <h2><img src="../assets/products.png" alt="我们的产品"/></h2>
        <div class="content">
          <img class="left img-product" src="../assets/product1.png"/>
          <div>
            <div class="header"><img src="../assets/zhima.png" /><h3>芝麻开工</h3></div>
            <p>芝麻开工是专注于蓝领的一站式灵活用工招聘服务平台，致力于解决蓝领招聘难、成本高、效率低的招聘难题。针对求职者，打造一个快速便捷地找到真实、可靠工作的互联网招聘平台，同时也是一个人人都有机会成为经纪人免费赚取职位推荐奖金的平台。针对企业，我们提供专业的灵活用工服务，包括兼职招聘、在线众包和RPO等</p>
          </div>
        </div>
      </div>
    </section>
    <section class="contact">
      <div class="main-content">
        <h2><img src="../assets/contactus.png" alt="联系我们"/></h2>
        <div class="col">
          <div class="building">
            <h4>公司地址</h4>
            <p>上海市闵行区闵行区盘阳路59弄融信·绿地国际13号楼</p>
            <h4>商务合作</h4>
            <p>+86 166-0176-4218</p>
          </div>
          <img class="map" src="../assets/map.jpg"/>
        </div>
        <div style="text-align:center;margin-top:50px">上海彩住科技有限责任公司  |  <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备 20021350号-3号</a> <br/>Copyright ©2021</div>
      </div>
    </section>
  </div>
</template>

<script>
// import Vue from 'vue'
import { Slider, SliderItem } from 'vue-easy-slider'

export default {
	name: 'app',
  components:{
    Slider,
    SliderItem,
  },
	data() {
		return {
			list: [],
      curr: 1
		};
	},
	methods: {
    showContent(num) {
      this.curr = num
    },
    hideContent(num) {
      this.curr = num
    }
	}
};
</script>

<style scoped>
.main-content{
  max-width: 1200px;
  margin: 0 auto;
}
.index {
  height: 1080px;
  background: url(../assets/index.png) no-repeat;
  background-size: cover;
}
.header-nav{
  display: inline-block;
  width: 100%;
}
.header-nav .logo img{
  height: 40px;
}
.header-nav .nav-menu{
  display: inline-block;
  float: right;
  height: 40px;
  list-style: none;
  line-height: 40px;
}
.header-nav .nav-menu li{
  float: left;
  margin-left: 80px;
  color: #fff;
  font-size: 16px;
  font-weight: 300;
  position: relative;
}
.header-nav .nav-menu li.active::after{
  content: "";
  width: 100%;
  height: 2px;
  background: #fff;
  position: absolute;
  left: 0;
  bottom: -8px;
}
.main-content h1{
  margin: 0 auto;
  width: 800px;
  text-align: center;
  margin-top: 400px;
}
.main-content h1 img{
  height: 60px;
}
.main-content h2 {
  width:100%;
  text-align: center;
  margin-bottom: 45px;
}
.main-content h2 img{
  height: 26px;
}
.aboutus .desc{
  text-align: center;
}
.aboutus .profile{
  margin-top: 70px;
  height: 560px;
  overflow: hidden;
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1200px;
}
.aboutus .profile .profile-scroll{
  display: flex;
}
.aboutus .profile1{
  display: none;
}
.aboutus .profile .item{
  width: 400px;
  display: inline-block;
  height: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.aboutus .profile .t1{
  list-style: none;
  text-align: center;
  /* border: 1px solid red; */
  /* margin-top: 100px; */
}
.aboutus .team{
  background: url('../assets/team.png') no-repeat;
  background-size: cover;
  color: #fff;
}
.aboutus .num{
  font-size: 60px;
  font-weight: 100;
  margin-bottom: 50px;
}
.aboutus .title{
  font-size: 34px;
  margin-bottom: 50px;
  position: relative;
}
.aboutus .title::after{
  width: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  height: 6px;
  background: #FA6969;
  content: "";
  bottom: -10px;
  z-index: 1;
}
.aboutus .content{
  font-size: 16px;
  /* word-spacing: 10px; */
  letter-spacing: 2px;
  line-height: 2;
  margin: 0 50px;
}
.aboutus .tech{
  background: url('../assets/tech.png') no-repeat;
  background-size: cover;
  color: #fff;
}
.aboutus .joinus{
  background: url('../assets/join.png') no-repeat;
  background-size: cover;
  color: #fff;
}
.product{
  background:#f9f9f9
}
.product .content{
  display: flex;
  justify-content: space-between;
}
.product .content .header{
  display: flex;
  align-items: center;
}
.product .content .left{
  margin-right: 200px;
}
.product .content img{
  height: 400px;
}
.product .content .header img{
  height: 80px;
}
.contact{
  background: #f9f9f9;
}
.contact .col{
  display: flex;
}
.contact .building{
  width: 300px;
  /* height: 200px; */
  background: url('../assets/map-build.png') no-repeat;
  background-size: cover;
  padding: 80px 50px;
}
.contact .map{
  width: 800px;
}
@media (max-width: 1200px){
  .header-nav .nav-menu{
    display: none;
  }
  .logo img{
    margin-left: 20px;
  }
  section{
    width: 100%;
  }
  .main-content h1{
    width: 100%;
    margin-top: 100px;
  }
  .main-content h1 img{
    width: 60%;
    height: auto;
  }
  .index{
    height: 300px;
  }
  .main-content{
    display: flex;
    flex-direction: column;
  }
  .product .content{
    flex-direction: column;
    box-sizing: border-box;
    padding: 0 30px;
  }
  .main-content.fixed .content{
    flex-direction: column-reverse;
  }
  .product .content img.img-product{
    height: 300px;
  }
  .product .content .header{
    justify-content: center;
    margin-top: 20px;
  }
  .product .content .left{
    margin-right: 0;
  }
  .aboutus .profile {
    overflow-x: auto;
    width: 100%;
  }
  .aboutus .profile .profile-scroll{
    width: 1200px;
  }
  .aboutus .profile .item{
    width: 30%;
    min-width: 400px;
    /* height: 400px; */
  }
  .aboutus .title{
    font-size: 24px;
  }
  .aboutus .content{
    font-size: 14px;
    margin: 0 40px;
  }
  .aboutus .title::after{
    width: 20%;
    margin-left: -10%;
  }
  .contact .col{
    flex-direction: column-reverse;
  }
  .contact .map{
    width: 100%;
    height: 200px;
  }
  .contact .building{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 40px;
  }
  .aboutus .profile{
    overflow-x: auto;
    display: none;
  }
  .aboutus .profile1{
    display: block;
  }
  .profile1 >>> .slider{
    height: 560px !important;
  }
  .profile1{
    margin-top: 40px;
  }
  .profile1 .item{
    height: 100%;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  }
  .profile1 .num{
    text-align: center;
  }
  .profile1 .title{
    text-align: center;
  }
}
</style>
